import axios from "axios";

// Resuelve la URL base del backend.
// 1) Si REACT_APP_BACKEND_URL está definida (preview), úsala.
// 2) Si no, usa el mismo origin que sirve el frontend (caso producción: eksvidi.com).
// Esto evita tener que configurar REACT_APP_BACKEND_URL como secret en el deploy.
const RAW = (typeof process !== "undefined" && process.env && process.env.REACT_APP_BACKEND_URL) || "";
export const BACKEND_URL = (RAW && RAW.trim()) || (typeof window !== "undefined" ? window.location.origin : "");
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("vp_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function wsUrl(token, role, authToken) {
  const base = BACKEND_URL.replace(/^http/, "ws");
  const params = new URLSearchParams({ role });
  if (authToken) params.set("auth", authToken);
  return `${base}/api/ws/${token}?${params.toString()}`;
}

export function publicAppOrigin() {
  return window.location.origin;
}

export async function fetchIceServers() {
  try {
    const r = await fetch(`${API}/ice-servers`);
    if (!r.ok) throw new Error("ICE servers fetch failed");
    const d = await r.json();
    return d.iceServers || [];
  } catch (e) {
    console.warn("[ice] fallback to public STUN", e);
    return [
      { urls: "stun:stun.l.google.com:19302" },
      { urls: "stun:stun1.l.google.com:19302" },
    ];
  }
}
